import { POSTAL_CODE_NA } from '@equidefi/constants/countries';
import { parsePhoneNumber } from 'react-phone-number-input';

// helpers/string.ts
var normalizePhoneNumber = (value) => {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  const parsed = parsePhoneNumber(trimmed, "US");
  return parsed?.isValid() ? parsed.number : null;
};
var blankIfNA = (value) => value == null || value === POSTAL_CODE_NA ? "" : value;
var maskEmail = (email) => {
  const [local, domain] = email.split("@");
  return `${local.slice(0, 1)}\u2022\u2022\u2022@${domain}`;
};
var maskPhone = (phone) => {
  const last4 = phone.replace(/\D/g, "").slice(-4);
  return `\u2022\u2022\u2022-\u2022\u2022\u2022-${last4}`;
};
var formatPhoneNumber = (str) => {
  const cleaned = `+1${str}`.replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
};
function splitName(fullName) {
  const parts = (fullName ?? "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { first_name: "", middle_name: "", last_name: "" };
  if (parts.length === 1) return { first_name: parts[0], middle_name: "", last_name: "" };
  const [first, ...rest] = parts;
  const last = rest.pop();
  return { first_name: first, middle_name: rest.join(" "), last_name: last };
}
function trimObjectStrings(data) {
  return Object.entries(data).reduce((acc, [key, value]) => {
    if (typeof value === "string") {
      acc[key] = value.trim();
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
}
function parseS3Url(input) {
  if (typeof input !== "string") {
    console.error(`Invalid S3 URL: ${input}`);
    return { bucket: null, key: null, region: null, url: null };
  }
  const parsed = new URL(input);
  parsed.search = "";
  const url = parsed.toString();
  let match = url.match(/^s3:\/\/([^\/]+)\/(.+)$/i);
  if (match) {
    const [, bucket, key] = match;
    return { bucket, key, region: void 0, url };
  }
  match = url.match(/^https?:\/\/([^\.]+)\.s3[.-]([^\.]+)\.amazonaws\.com\/(.+)$/i);
  if (match) {
    const [, bucket, region, key] = match;
    return { bucket, region, key, url };
  }
  match = url.match(/^https?:\/\/s3[.-]([^\.]+)\.amazonaws\.com\/([^\/]+)\/(.+)$/i);
  if (match) {
    const [, region, bucket, key] = match;
    return { bucket, region, key, url };
  }
  return { bucket: null, key: null, region: null, url: null };
}

export { blankIfNA, formatPhoneNumber, maskEmail, maskPhone, normalizePhoneNumber, parseS3Url, splitName, trimObjectStrings };
